import {
  collection as rawCollection,
  collectionGroup as rawCollectionGroup,
  query as rawQuery,
  where as rawWhere,
  orderBy as rawOrderBy,
  limit as rawLimit,
  select as rawSelect,
  startAt as rawStartAt,
  startAfter as rawStartAfter,
  endAt as rawEndAt,
  endBefore as rawEndBefore,
  type QueryConstraint,
  type CollectionReference,
  type Query,
} from './db/rethink-firestore';

/**
 * All collections live under the `bimbingan_` prefix. Keeping every collection
 * namespaced this way isolates the app's data inside the shared RethinkDB
 * instance used by the rethink-firestore bridge.
 */
export const COL = {
  users: 'bimbingan_users',
  dosenRoles: 'bimbingan_dosen_roles',
  mahasiswa: 'bimbingan_mahasiswa',
  skripsi: 'bimbingan_skripsi',
  skripsiTeam: 'bimbingan_skripsi_team',
  sessions: 'bimbingan_sessions',
  events: 'bimbingan_events',
  requests: 'bimbingan_requests',
  submissions: 'bimbingan_submissions',
  konsultasiPa: 'bimbingan_konsultasi_pa',
  paRequests: 'bimbingan_pa_requests',
  consults: 'bimbingan_consults',
  consultMessages: 'bimbingan_consult_messages',
  pengajuanJudul: 'bimbingan_pengajuan_judul',
  skripsiHistory: 'bimbingan_skripsi_history',
  persyaratan: 'bimbingan_persyaratan',
  persyaratanSubmission: 'bimbingan_persyaratan_submission',
  beritaAcara: 'bimbingan_berita_acara',
  notifications: 'bimbingan_notifications',
  settings: 'bimbingan_settings',
  prodi: 'bimbingan_prodi',
  jurusan: 'bimbingan_jurusan',
  fakultas: 'bimbingan_fakultas',
} as const;

export type CollectionName = (typeof COL)[keyof typeof COL];

/** Type-safe collection reference factory (prefix applied). */
export function col<T = any>(name: CollectionName): CollectionReference<T> {
  return rawCollection(undefined, name) as unknown as CollectionReference<T>;
}

export function collectionGroup<T = any>(name: CollectionName): Query<T> {
  return rawCollectionGroup(undefined, name) as unknown as Query<T>;
}

export const where = rawWhere;
export const orderBy = rawOrderBy;
export const limit = rawLimit;
export const select = rawSelect;
export const startAt = rawStartAt;
export const startAfter = rawStartAfter;
export const endAt = rawEndAt;
export const endBefore = rawEndBefore;
export type { QueryConstraint, CollectionReference, Query };

export function q<T = any>(
  ref: CollectionReference<T>,
  ...constraints: QueryConstraint[]
): Query<T> {
  // Boundary cast: doc interfaces lack an index signature, so
  // CollectionReference<T> is not assignable to the adapter's
  // CollectionReference<DocumentData> — narrowed, never `any`.
  return rawQuery(ref as unknown as CollectionReference, ...constraints) as unknown as Query<T>;
}
